import closeDropdown from "./closeDropdown";
import syncOptionStates from "./syncOptionStates";
import syncSelectedLabel from "./syncSelectedLabel";
import toggleDropdown from "./toggleDropdown";

type BindDropdownEventsArgs = {
  selectElement: HTMLSelectElement;
  dropdownButton: HTMLButtonElement;
  dropdownMenu: HTMLDivElement;
  wrapperElement: HTMLDivElement;
};

const bindDropdownEvents = ({
  selectElement,
  dropdownButton,
  dropdownMenu,
  wrapperElement,
}: BindDropdownEventsArgs) => {
  dropdownButton.addEventListener("click", () => {
    toggleDropdown(dropdownButton, dropdownMenu);
  });

  selectElement.addEventListener("change", () => {
    syncSelectedLabel(selectElement, dropdownButton);
    syncOptionStates(selectElement, dropdownMenu);
  });

  document.addEventListener("click", (clickEvent) => {
    if (!wrapperElement.contains(clickEvent.target as Node)) {
      closeDropdown(dropdownButton, dropdownMenu);
    }
  });

  document.addEventListener("keydown", (keyboardEvent) => {
    if (keyboardEvent.key === "Escape") {
      closeDropdown(dropdownButton, dropdownMenu);
    }
  });

  syncOptionStates(selectElement, dropdownMenu);
};

export default bindDropdownEvents;
